/** 로그인 사용자 식별자. 로그인 경로 전체가 sessionStorage.loginUser 를 세팅한다 */
export const getUsrInfoId = () => {
    try {
        return JSON.parse(sessionStorage.getItem('loginUser'))?.usrInfoId || 'me';
    } catch (e) {
        return 'me';
    }
};
